import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Label } from 'lib/Label';
import { Store } from 'components/common/types/Store.types';
import moneySvg from 'assets/icons/money.svg';
import framesSvg from 'assets/icons/frame.svg';
import eyeSvg from 'assets/icons/eye_empty.svg';
import { TargetLabel } from 'consts/targetLabel';
import ObjectiveTarget from './ObjectiveTarget';
import { TargetType } from '../../../TargetSection/TargetSection.types';

const ObjectiveTargets: React.FC = () => {
  const { budget, frames, impressions } = useSelector((state: Store) => state.objective.data);

  const objectiveTargets = useMemo(
    () => [
      {
        target: budget,
        targetType: TargetType.BUDGET,
        label: TargetLabel.BUDGET,
        icon: moneySvg,
      },
      {
        target: frames,
        targetType: TargetType.FRAMES,
        label: TargetLabel.FRAMES,
        icon: framesSvg,
      },
      {
        target: impressions,
        targetType: TargetType.IMPRESSIONS,
        label: TargetLabel.IMPRESSIONS,
        icon: eyeSvg,
      },
    ],
    [budget, frames, impressions],
  );

  return (
    <div data-test-id="objective-panel-targets-section">
      <Label label="Targets" />
      {objectiveTargets.map(({ target, targetType, label, icon }) => (
        <ObjectiveTarget key={targetType} objectiveTarget={target} targetType={targetType} label={label} icon={icon} />
      ))}
    </div>
  );
};

export default ObjectiveTargets;
